import React, { useEffect, useMemo } from 'react';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';

// ColumnDefs import
import {
  getColumnDefs1,
  getColumnDefs2,
  getColumnDefs3,
} from './RIS_BASIC_01_ColumnDefs';

// 모든 모달 컴포넌트 import
import IDConfigModal from './modals/IDConfigModal';
import BasicInfoModal from './modals/BasicInfoModal';
import EtcInfoModal from './modals/EtcInfoModal';
import ProcessSelectModal from './modals/ProcessSelectModal';
import RiskAssessmentListModal from './modals/RiskAssessmentListModal';
import StandardModelModal from './modals/StandardModelModal';
import RiskAssessment3LevelModal from './modals/RiskAssessment3LevelModal';
import RiskAssessmentFrequencyModal from './modals/RiskAssessmentFrequencyModal';
import ItemSelectModal from './modals/ItemSelectModal';
import SafetyHealthInfoModal from './modals/SafetyHealthInfoModal';
import ProcessRegisterModal from './modals/ProcessRegisterModal';
import MethodSelectModal from './modals/MethodSelectModal';

function RIS_BASIC_01(props) {
  //#region 컬럼 정의
  // 콜백을 사용하여 컬럼 정의 생성
  // const columnDefs1 = getColumnDefs1(props);
  const columnDefs1 = useMemo(
    () => getColumnDefs1(props),
    [
      // props의 실제 의존성만 포함
      props.DeleteNewRow1,
      props.RestoreRow1,
      props.gridRef1,
      props.rowData1,
      props.selectedRowNosRef1,
      props.lastCheckedIndexRef1,
      props.handleRowSelection1,
      props.openModal,
      props.dispatch,
      props.showSnackbar,
      props.setSelectedRowData1,
      props.gjValue,
      props.Search6,
    ]
  );
  const columnDefs2 = useMemo(
    () => getColumnDefs2(props),
    [
      // props의 실제 의존성만 포함
      props.DeleteNewRow1,
      props.RestoreRow1,
      props.gridRef6, // 모달 그리드 ref 사용
      props.modalRowData6 || [],
      props.selectedRowNosRef2,
      props.lastCheckedIndexRef2,
      props.handleRowSelection2,
    ]
  );
  const columnDefs3 = useMemo(
    () => getColumnDefs3(props),
    [
      // props의 실제 의존성만 포함
      props.gridRef5, // 모달 그리드 ref 사용
      props.modalRowData4 || [],
      props.selectedModalRowNosRef4,
      props.lastCheckedIndexRef3,
      props.handleRowSelection3,
    ]
  );
  //#endregion

  //#region Event Handlers
  /**
   * Handle cell click on main grid
   */
  const handleCellClick1 = (e) => {
    const gridApi = props.gridRef1?.current?.api;
    if (!gridApi) return;

    const clickedRowIndex = e.rowIndex;
    const isCheckboxClick = e.event?.target?.type === 'checkbox';

    if (!isCheckboxClick) {
      gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
      gridApi.setFocusedCell(clickedRowIndex, 'rsNm');

      if (props.handleRowSelection1) {
        const copied = JSON.parse(JSON.stringify(e.data));
        props.handleRowSelection1([copied]);
      }

      gridApi.getDisplayedRowAtIndex(clickedRowIndex)?.setSelected(true, false);
    }
  };

  /**
   * Handle selection changed on main grid
   */
  const handleSelectionChanged1 = () => {
    const gridApi = props.gridRef1?.current?.api;
    if (!gridApi) return;

    const selectedNodes = gridApi.getSelectedNodes();
    const selectedData = selectedNodes.map((n) => n.data);
    if (props.selectedRowNosRef1?.current) {
      props.selectedRowNosRef1.current = new Set(selectedData.map((r) => r.no));
    }

    if (props.setSelectedRowData1) {
      props.setSelectedRowData1(selectedData);
    }
  };

  /**
   * Handle cell value changed on main grid
   */
  const handleCellValueChanged1 = (e) => {
    e.data.editYn = 'Y';

    const key = e.data.no;
    props.setChangedRowData1?.((prev) => {
      const filtered = prev.filter((row) => row.no !== key);
      return [...filtered, { ...e.data }];
    });
  };

  /**
   * Handle add row on main grid
   */
  const handleAddRow1 = (e) => {
    props.ResetLogic3();
    props.resetProcessState();

    // SafetyHealthInfoModal을 빈 상태로 열기
    props.openModal?.('safetyHealthInfo');
  };

  /**
   * Handle delete rows on main grid
   */
  const handleDeleteRows1 = () => {
    if (!props.validateSelection()) return;

    const newRowExists = props.selectedRowData1.some(
      (row) => row.newYn === 'Y'
    );

    if (!newRowExists) {
      props.MarkedForDeletion1(props.selectedRowData1);
    } else {
      props.NewYnErrorMsg();
    }
  };

  /**
   * Handle refresh main grid
   */
  const handleRefresh1 = () => {
    if (!props.validateSelection()) return;
    props.SearchLogic1();
  };

  /**
   * Handle open 3-level assessment modal
   */
  const handleOpen3LevelModal = () => {
    if (!props.selectedRowData1 || props.selectedRowData1.length === 0) {
      props.dispatch?.(
        props.showSnackbar?.({
          message: '항목을 선택하세요.',
          type: 'warning',
        })
      );
      return;
    }

    const selectedRow = props.selectedRowData1[0];
    if (selectedRow.rsMethod !== '위험성 수준 3단계 판단법') {
      props.dispatch?.(
        props.showSnackbar?.({
          message: '위험성 수준 3단계 판단법으로 평가된 항목만 볼 수 있습니다.',
          type: 'warning',
        })
      );
      return;
    }

    props.openModal?.('riskAssessment3Level');
    if (props.SearchLogic2_1) {
      props.SearchLogic2_1(props.gjValue);
    }
  };

  /**
   * Handle open frequency-intensity modal
   */
  const handleOpenFrequencyModal = () => {
    if (!props.selectedRowData1 || props.selectedRowData1.length === 0) {
      props.dispatch?.(
        props.showSnackbar?.({
          message: '항목을 선택하세요.',
          type: 'warning',
        })
      );
      return;
    }

    const selectedRow = props.selectedRowData1[0];
    if (selectedRow.rsMethod !== '빈도·강도법') {
      props.dispatch?.(
        props.showSnackbar?.({
          message: '빈도·강도법으로 평가된 항목만 볼 수 있습니다.',
          type: 'warning',
        })
      );
      return;
    }

    props.openModal?.('riskAssessmentFrequency');
    if (props.SearchLogic2_2) {
      props.SearchLogic2_2(props.gjValue);
    }
  };

  /**
   * Handle open basic info modal
   */
  const handleOpenBasicInfoModal = () => {
    if (!props.selectedRowData1 || props.selectedRowData1.length === 0) {
      props.dispatch?.(
        props.showSnackbar?.({
          message: '항목을 선택하세요.',
          type: 'warning',
        })
      );
      return;
    }

    props.openModal?.('basicInfo');
    if (props.setInputsFromRowData) {
      props.setInputsFromRowData(props.selectedRowData1[0]);
    }
  };

  //#endregion

  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => params.data.no}
        title1={'위험성평가 사전준비'}
        fileUploadYn1="N"
        fileUploadClick1={() => {
          if (!props.validateSelection()) return;
          props.fileInputRef?.current?.click();
        }}
        // fileDownloadYn1="N"
        // fileDownloadClick1={() => {
        //   if (!props.validateSelection()) return;

        //   if (props.selectedRowData1.length === 0) {
        //     // 선택된 행이 없으면 평가 방법 선택 모달 열기
        //     props.openModal?.('methodSelect');
        //     return;
        //   }

        //   props.selectedRowData1.forEach((item, index) => {
        //     props.SearchLogic8({ rsCd: item.rsCd });
        //   });
        // }}
        addClick1={handleAddRow1}
        deleteClick1={handleDeleteRows1}
        refreshClick1={handleRefresh1}
        gridRef={props.gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        editable={true}
        rowSelection="multiple"
        onCellClicked={handleCellClick1}
        onSelectionChanged={handleSelectionChanged1}
        onCellValueChanged={handleCellValueChanged1}
      />

      {/* ID Config Modal */}
      <IDConfigModal
        open={props.modals?.idConfig || false}
        onClose={() => props.closeModal?.('idConfig')}
        onSave={() => {
          // Handle ID config save
          props.closeModal?.('idConfig');
        }}
        rowData={props.modalRowData2 || []}
        // columnDefs={columnDefs3}
        gridRef={props.gridRef3}
        selectedRowData={props.selectedModalRowData2}
        setSelectedRowData={props.setSelectedModalRowData2}
        gridRefToUpdate={props.gridRef2_1}
        rowClickData={props.rowClickData}
      />

      {/* Basic Info Modal */}
      <BasicInfoModal
        open={props.modals?.basicInfo || false}
        onClose={() => props.closeModal?.('basicInfo')}
        onSave={props.handleSave3}
        inputs={props.inputs}
        setInputs={props.setInputs}
        depData={props.depData}
        PreviewRender={props.PreviewRender}
        FileUpload={props.FileUpload}
        resetAddButtonError={props.resetAddButtonError}
        dispatch={props.dispatch}
      />

      {/* Standard Model Modal */}
      <StandardModelModal
        open={props.modals?.standardModel || false}
        onClose={() => props.closeModal?.('standardModel')}
        onConfirm={(selectedRows) => {
          const list = Array.isArray(selectedRows)
            ? selectedRows
            : [selectedRows].filter(Boolean);
          const row = list[0];
          props.setHazardSituation?.(
            String(row?.categoryComment ?? row?.CategoryComment ?? '').trim()
          );
          props.closeModal?.('standardModel');
        }}
        rowData={props.modalRowData4 || []}
        columnDefs={columnDefs3}
        gridRef={props.gridRef5}
        searchRef={props.searchRef}
        resetAddButtonError={props.resetAddButtonError}
        showSnackbar={props.showSnackbar}
        dispatch={props.dispatch}
        setSelectedRowData={props.setSelectedModalRowData4}
        selectedRowData={props.selectedModalRowData4}
      />

      {/* Risk Assessment 3-Level Modal */}
      <RiskAssessment3LevelModal
        open={props.modals?.riskAssessment3Level || false}
        onClose={() => props.closeModal?.('riskAssessment3Level')}
        onSave={props.Save4}
        resetAddButtonError={props.resetAddButtonError}
        dispatch={props.dispatch}
        FileChange={props.FileChange}
        riskAssessmentModalData={props.riskAssessmentModalData || []}
        setRiskAssessmentModalData={props.setRiskAssessmentModalData}
        onOpenStandardModel={() => {
          props.setModalGridRef4?.(props.gridRef2_1);
          props.openModal?.('standardModel');
          if (props.SearchLogic7) {
            props.SearchLogic7();
          }
        }}
        hazardSituation={props.hazardSituation}
        setHazardSituation={props.setHazardSituation}
        selectedRowData={props.selectedRowData1}
        ExcelDownload1={props.ExcelDownload1}
      />

      {/* Risk Assessment Frequency Modal */}
      <RiskAssessmentFrequencyModal
        open={props.modals?.riskAssessmentFrequency || false}
        onClose={() => props.closeModal?.('riskAssessmentFrequency')}
        onSave={props.handleSave2_2}
        onOpenStandardModel={(gridRef) => {
          props.setModalGridRef4?.(gridRef);
          props.openModal?.('standardModel');
          if (props.SearchLogic7) {
            props.SearchLogic7();
          }
        }}
        onSearch={props.SearchLogic2_2}
        rowData={props.modalRowData1_2 || []}
        // columnDefs={columnDefs2_2}
        gridRef={props.gridRef2_2}
        selectedRows={props.selectedModalRowData1_2}
        setSelectedRows={props.setSelectedModalRowData1_2}
        setChangedRows={props.setChangedModalRowData1_2}
        changedRows={props.changedModalRowData1_2}
        deletedRows={props.deletedModalRowData1_2}
        onMarkForDeletion={props.MarkedForDeletion2_2}
        onRowClick={(data) => props.setSelectedModalRowData1_2?.([data])}
        selectedRowNosRef={props.selectedModalRowNosRef1_2}
        departmentList={props.gjList}
        selectedDepartment={props.gjValue}
        onDepartmentChange={props.setGjValue}
        resetAddButtonError={props.resetAddButtonError}
        showErrorMsg={props.NewYnErrorMsg}
        dispatch={props.dispatch}
      />

      {/* Risk Assessment List Modal (for loading existing assessments) */}
      <RiskAssessmentListModal
        open={props.modals?.riskAssessmentList || false}
        onClose={() => props.closeModal?.('riskAssessmentList')}
        onSelect={(selectedRow) => {
          // inputs.rsCd가 있으면 기존 데이터 수정, 없으면 신규 추가
          const isExistingData = !!props.inputs?.rsCd;
          if (props.setInputsFromRowData) {
            props.setInputsFromRowData(selectedRow, isExistingData);
          }
          if (props.SearchLogic2) {
            props.SearchLogic2(selectedRow, { shouldSetRsCd: isExistingData });
          }
        }}
        onDoubleClick={(rowData) => {
          const isExistingData = !!props.inputs?.rsCd;

          if (props.setInputsFromRowData) {
            props.setInputsFromRowData(rowData, isExistingData);
          }
          if (props.SearchLogic2) {
            props.SearchLogic2(rowData, { shouldSetRsCd: isExistingData });
          }
        }}
        rowData={props.modalRowData6 || []}
        columnDefs={columnDefs2}
        gridRef={props.gridRef6}
        searchText={props.modalSearchText6}
        setSearchText={props.setModalSearchText6}
      />

      {/* Process Select Modal */}
      <ProcessSelectModal
        open={props.processSelectModalOpen || false}
        onClose={() => props.setProcessSelectModalOpen?.(false)}
        onConfirm={props.handleConfirmProcessSelection}
        depData={props.depData || []}
        processDataByDept={props.processDataByDept || {}}
        selectedDepartments={props.selectedDepartments || []}
        onToggleDepartment={props.handleToggleDepartment}
        selectedProcessCodes={props.selectedProcessCodes || []}
        onToggleProcessCode={props.handleToggleProcessCode}
        onDragEnd={props.handleDragEndProcess}
        onClearAll={props.handleClearAllProcesses}
        onOpenRegisterModal={props.handleOpenProcessRegisterModal}
      />
      {/* Process Select Modal 안 공정 등록 */}
      <ProcessRegisterModal
        open={props.processRegisterModalOpen || false}
        onClose={() => props.setProcessRegisterModalOpen?.(false)}
        onRegister={props.handleRegisterProcess}
        processRegisterData={props.processRegisterData}
        setProcessRegisterData={props.setProcessRegisterData}
        depData={props.depData || []}
        currentStep={2}
        SaveLogic2={props.SaveLogic2}
      />
      {/* Item Select Modal (Facility or Material) */}
      <ItemSelectModal
        open={props.itemSelectModalOpen || false}
        onClose={() => props.setItemSelectModalOpen?.(false)}
        onConfirm={props.handleConfirmItemSelection}
        modalConfig={props.itemModalConfig}
        modalType={props.itemSelectModalType}
      />

      {/* Etc Info Modal */}
      <EtcInfoModal
        open={props.etcInfoModalOpen || false}
        onClose={() => props.setEtcInfoModalOpen?.(false)}
        onSave={props.handleConfirmEtcInfo}
        form={props.etcInfoForm}
        onFieldChange={props.handleEtcInfoFormChange}
        onTransportMeansToggle={props.handleTransportMeansToggle}
      />

      {/* Safety Health Info Modal (Most Complex) */}
      <SafetyHealthInfoModal
        open={props.modals?.safetyHealthInfo || false}
        onClose={() => props.closeModal?.('safetyHealthInfo')}
        onSave={props.SaveLogic1}
        onOpenLoadModal={() => {
          props.openModal?.('riskAssessmentList');
          if (props.SearchLogic1) {
            props.SearchLogic1();
          }
        }}
        basicInfoInputs={props.inputs}
        setBasicInfoInputs={props.setInputs}
        DepCdMultiSelectCell={props.DepCdMultiSelectCell}
        tableData={props.tableData3}
        depData={props.depData}
        onClearAllProcesses={props.handleClearAllProcesses}
        selectedProcessList={props.processList || []}
        setSelectedProcessList={props.setProcessList}
        expandedAccordion={props.expandedAccordion}
        setExpandedAccordion={props.setExpandedAccordion}
        onAddDetailTask={props.handleAddDetailTask}
        onRemoveDetailTask={props.handleRemoveDetailTask}
        onDetailTaskChange={props.handleDetailTaskChange}
        onRemoveProcess={props.handleRemoveProcess}
        processSelectModalOpen={props.processSelectModalOpen}
        setProcessSelectModalOpen={props.setProcessSelectModalOpen}
        onConfirmProcessSelection={props.handleConfirmProcessSelection}
        onOpenProcessSelectModal={props.handleOpenProcessSelectModal}
        processDataByDept={props.processDataByDept}
        selectedDepartments={props.selectedDepartments}
        onToggleDepartment={props.handleToggleDepartment}
        selectedProcessCodes={props.selectedProcessCodes}
        onToggleProcessCode={props.handleToggleProcessCode}
        onDragEndProcess={props.handleDragEndProcess}
        itemSelectModalOpen={props.itemSelectModalOpen}
        setItemSelectModalOpen={props.setItemSelectModalOpen}
        itemModalConfig={props.itemModalConfig}
        itemSelectModalType={props.itemSelectModalType}
        onConfirmItemSelection={props.handleConfirmItemSelection}
        onCloseItemSelectModal={props.handleCloseItemSelectModal}
        onOpenFacilitySelectModal={props.handleOpenFacilitySelectModal}
        onOpenMaterialSelectModal={props.handleOpenMaterialSelectModal}
        etcInfoModalOpen={props.etcInfoModalOpen}
        setEtcInfoModalOpen={props.setEtcInfoModalOpen}
        etcInfoForm={props.etcInfoForm}
        onEtcInfoFormChange={props.handleEtcInfoFormChange}
        onTransportMeansToggle={props.handleTransportMeansToggle}
        onConfirmEtcInfo={props.handleConfirmEtcInfo}
        onOpenEtcInfoModal={props.handleOpenEtcInfoModal}
      />

      {/* Method Select Modal */}
      <MethodSelectModal
        open={props.modals?.methodSelect || false}
        onClose={() => props.closeModal?.('methodSelect')}
        onConfirm={(selectedMethod) => {
          props.closeModal?.('methodSelect');
          // 빈 데이터로 엑셀 다운로드 실행
          props.ExcelDownload1({ rsMethod: selectedMethod }, []);
        }}
      />

      {/* 엑셀 업로드용 숨김 파일 input */}
      <input
        type="file"
        ref={props.fileInputRef}
        style={{ display: 'none' }}
        accept=".xlsx,.xls"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            props.ExcelUpload1(file);
            // 같은 파일을 다시 선택할 수 있도록 초기화
            e.target.value = '';
          }
        }}
      />
    </React.Fragment>
  );
}

export default RIS_BASIC_01;
